<template>
  <div class="column">
    <tx-bg src="oldclassic_m_roleinfo_img_yhz_db_1">
      <!-- <tx-bg src="oldclassic_m_roleinfo_img_yhz_db_3" class="btn_yeqian3"> -->
      <tx-bg src="oldclassic_m_roleinfo_img_biaoti" class="btn_yeqian">
        基本信息
      </tx-bg>
      <!-- </tx-bg> -->

      <div class="column px-40 mt-40" v-if="tree_num1">
        <t-row
          title="神通点"
          valueClass="roleinfo-attr-value row-value-bg"
          :value="phantom['new_shentong_total'] || 0"
          class="m-tb-4"
        />

        <!-- TODOD -->
        <t-row
          title="已加点"
          valueClass="roleinfo-attr-value row-value-bg"
          :value="phantom['new_shentong_total'] - phantom['new_shentong']"
          class="m-tb-4"
        />
      </div>

      <template v-if="tree_num2">
        <div class="middle mt-40">
          <tx-bg src="oldclassic_m_roleinfo_img_biaoti" class="btn_yeqian">
            召唤
          </tx-bg>
        </div>
        <div class="column px-40">
          <t-row
            title="神通点"
            valueClass="roleinfo-attr-value row-value-bg"
            :value="phantom['new_summon_total'] || 0"
            class="m-tb-4"
          />

          <!-- TODOD -->
          <t-row
            title="已加点"
            valueClass="roleinfo-attr-value row-value-bg"
            :value="phantom['new_summon_total'] - phantom['new_summon']"
            class="m-tb-4"
          />
        </div>
      </template>
    </tx-bg>

    <tx-bg src="oldclassic_m_roleinfo_img_jn_db" :size="bg_size">
      <!-- <tx-bg src="oldclassic_p_roleinfo_img_yhzbiaoti_db" class="btn_yeqian3"> -->
      <tx-bg
        src="oldclassic_m_roleinfo_img_biaoti"
        class="btn_yeqian sts-title"
      >
        神通树
      </tx-bg>
      <div class="px-40 pt-16" v-if="tree_num1">
        <div class="middle">
          <div class="sts-bg mt-24">
            <template v-for="(v, k) in tree_desc(tree_num1)">
              <mCommonItem
                class="sts-item"
                :style="coordinate(v['coordinate'])"
                :key="k"
                v-if="v['icon']"
                :content="v['content']"
                :score="tree_level(tree_num1)[k] || 0"
                :src="yhz_img2(v['icon'], 2)"
              />
            </template>
          </div>
        </div>
      </div>
    </tx-bg>
  </div>
</template>

<script setup>
// import { defineProps, ref, computed, inject } from 'vue';
import px2vw from '@/utils/px2vw_v2';
const { is_mobile } = inject('GlobalStore');

const { yhz_img2, bg_num } = inject('filters');

const bg_size = ref({ width: 584, height: 1250 });

const props = defineProps({
  phantom: {
    type: Object,
    default: () => ({}),
  },
});

const coordinate = (value) => {
  let result = {};
  if (value) {
    console.log('value', value);
    let offset = 0;
    if (value[0] < 86) {
      offset = 1;
    } else if (value[0] > 86) {
      offset = -1;
    }
    result = {
      left: px2vw((value[0] + 1.5) * 1.5, is_mobile.value),
      top: px2vw((value[1] + 5) * 1.5, is_mobile.value),
    };
  }
  return result;
};

const tree_num1 = computed(() => {
  if (!props.phantom.new_tree_num) return false;
  return props.phantom.new_tree_num[0];
});

const tree_num2 = computed(() => {
  if (!props.phantom.new_tree_num) return false;
  return props.phantom.new_tree_num[1];
});

const tree_desc = computed(() => {
  return (tree_num) => props.phantom?.new_tree_desc[tree_num] || {};
});

const tree_level = computed(() => {
  return (tree_num) => props.phantom?.new_tree[tree_num] || {};
});
</script>


<style scoped lang="scss" >
.sts-bg {
  // width: 146px;
  // height: 528px; //  800 * 0.66 = 528

  // width: 221px;
  // height: 800px;

  width: 321px;
  height: 1200px;
  background: url('https://tx3.res.netease.com/qt/10/0427_yxb/images/yuanhun/st_tree_flower.png');
  background-repeat: round;
  position: relative;
  // zoom: 2;
}

// .yhz_skpostion li img {
//   width: 24px !important;
//   height: 24px !important;
// }

.sts-item {
  position: absolute;
  width: 60px !important;
  height: 60px !important;
}

.sts-title {
  // height: 100px;
  // border: 1px solid red;
  margin-top: 32px !important;
}
</style>